import React from 'react';
import styles from './admission-checklist-info.module.scss';
import { Lang } from 'shared/constants';
import { Modal } from 'src/components/design-system';
import { AdmissionBreadcrumbs } from 'src/components/breadcrumbs';
import { TagsIcons } from 'src/components/tags/tagsIcons';
import { TextTag } from 'src/components/tags/text-tags';

const DetailInfo = ({ label, value, link }) => {
  if (!value) return false;

  return (
    <div className={styles.detail}>
      <h6>{label}</h6>
      <div className={styles.detailContent}>
        {!link && value}
        {link && (
          <a href={link} target="_blank" rel="noreferrer">
            {value}
          </a>
        )}
      </div>
    </div>
  );
};

const AdmissionChecklistInfoComponent = React.memo(function AdmissionChecklistInfoComponent({
  id = null,
  item = {},
  lang = Lang.ADMISSION_INFORMATION_MODAL,
  admissionDetails = () => {},
  parents = [],
  admissionSelectChecklist = () => {},
}) {
  const close = React.useCallback(() => {
    admissionDetails(null);
  }, [admissionDetails]);

  const onNavigateToCategory = id => {
    close();
    admissionSelectChecklist(id);
  };

  let { info, tags } = item ?? {};

  const renderTags = () => {
    if (!tags?.contentType && !tags?.specialty) return null;

    return (
      <div className={styles.tagsContainer}>
        <TagsIcons tags={tags} hideTags={{ targetAudience: true, contentType: true }} />
        <TextTag tag={tags?.contentType} />
      </div>
    );
  };

  return (
    <Modal open={!!id} title={lang.HEADER} onCancel={close} cancelText={lang.DISMISS}>
      {renderTags()}
      <div className={styles.data}>
        <DetailInfo label={lang.INFO} value={info} />
      </div>

      <div className={styles.detail}>
        <h6>{lang.PARENTS_PATH}</h6>
        {parents.map(parent => (
          <AdmissionBreadcrumbs
            wrapperStyle={styles.breadcrumbs}
            pathParts={parent.pathParts}
            title={parent.title}
            key={parent.id}
            onCurrentClick={() => onNavigateToCategory(parent.id)}
            hideRoot
            initialWorkspaceId={parent.workspaceId}
            onPathClick={close}
          />
        ))}
      </div>
    </Modal>
  );
});

export { AdmissionChecklistInfoComponent };
